var render = function render(){var _vm=this,_c=_vm._self._c;return _c(require(`@assets/icons/${this.name}.svg`),_vm._b({tag:"component",staticClass:"BaseIcon"},'component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }